function DevPagePH3A() {
  return (
    <div>
      <iframe
        src="https://ads.context2.ai/banners-simple/render/698a330a05756e2b91b7b40d/68dfe2af38b769498f1cde85"
        width="300"
        height="250"
        scrolling="no"
        style={{ border: 'none', overflow: 'hidden' }}
      ></iframe>

      <iframe
        src="https://ads.context2.ai/banners-simple/render/698a330a05756e2b91b7b40d/68dfe2af38b769498f1cde86"
        width="300"
        height="250"
        scrolling="no"
        style={{ border: 'none', overflow: 'hidden' }}
      ></iframe>
    </div>
  );
}

export default DevPagePH3A;
